import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
import {} from "./formUtil";
import ForceActionButton from "./ForceActionButton.vue";
import FormCard from "@/components/Form/FormCard.vue";
import FormDisplay from "@/components/Form/FormDisplay.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InstanceForm',
    props: {
        title: null,
        inputs: { default: undefined },
        submitTitle: null,
        loadingMessage: null,
        busy: { type: Boolean },
        showForceActionButton: { type: Boolean, default: false }
    },
    emits: ["onSubmit", "onForceSubmit"],
    setup(__props, { emit }) {
        let formData;
        function onChange(incoming) {
            formData = incoming;
        }
        async function handleSubmit() {
            emit("onSubmit", formData);
        }
        async function handleForceSubmit() {
            emit("onForceSubmit", formData);
        }
        return { __sfc: true, emit, formData, onChange, handleSubmit, handleForceSubmit, BButton, ForceActionButton, FormCard, FormDisplay, LoadingSpan };
    }
});
